<aside class="toolchain-legend" aria-label="Toolchain progress">
  @for (item of steps(); track item.step.stepNo) {
    @let step = item.step;
    <div class="toolchain-legend__step">
      <button
        class="cui-card toolchain-legend__item"
        type="button"
        (click)="scrollToStep(step.stepNo)"
        [class.is-done]="item.presentation.color === 'success'"
        [class.is-error]="item.presentation.color === 'error'"
        [class.is-active]="item.presentation.color === 'warning'"
        [class.is-upcoming]="item.future">
        <span class="material-symbols-outlined">{{ item.presentation.icon }}</span
        ><span>{{ item.name }}</span>
      </button>
      @if (!$last) {
        <span class="material-symbols-outlined toolchain-legend__arrow" aria-hidden="true">
          south
        </span>
      }
    </div>
  }
</aside>
